export interface projectDetailsInvoiceDetailsState {
    projectDetailsInvoiceDetails: any | null;
  }
  
  export const initialprojectDetailsInvoiceDetailsState: projectDetailsInvoiceDetailsState = {
    projectDetailsInvoiceDetails: null
  };